import GenericRadioConfig from 'components/Configs/GenericRadioConfig';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import { PlayerHandedness, PitchTagging, StrikeZoneDisplay } from 'types/CodegenReportTypes';
import { useReportId } from 'hooks/helperHooks';
import useUmpireAdminReport from 'hooks/UmpireReport/AdminOverview/useUmpireAdminReport';
import SelectSession from 'components/Configs/SelectSession';
import { useTranslation } from 'react-i18next';
import SeePitchesBy from 'components/Configs/SeePitchesBy';

type Props = {
  isConfigOpen: boolean;
  setConfigOpen: () => void;
};

const AdminOverviewConfig = ({ isConfigOpen, setConfigOpen }: Props) => {
  const { isCreate } = useReportId();

  const { specialConfigOptions, selectedConfgValues, setSelectedConfigValue, isLoadingReport } = useUmpireAdminReport();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader isOpen={isConfigOpen} onClick={setConfigOpen} title={t('Adjust report content')} isEnabled={isCreate} />
      {isConfigOpen && (
        <div className='report-layout-shelf-section'>
          <SelectSession
            allSessions={specialConfigOptions?.availableSessions.map((option) => ({ label: option.name, value: option.id }))}
            excludedSessions={selectedConfgValues.excludedSessions.map((option) => ({ label: option.name, value: option.id }))}
            setExcludedSessions={(newValue) => setSelectedConfigValue('excludedSessions', newValue)}
            disabled={isLoadingReport || !specialConfigOptions || specialConfigOptions.availableSessions.length === 0}
          />
          <GenericRadioConfig
            label={t('Zone view:')}
            options={['WithBuffers', 'WithoutBuffers'] satisfies StrikeZoneDisplay[]}
            selected={selectedConfgValues.strikeZoneDisplay}
            setSelected={(newValue) => setSelectedConfigValue('strikeZoneDisplay', newValue)}
            disabled={isLoadingReport}
          />
          <GenericRadioConfig
            label={t('Pitch tagging:')}
            options={['Auto', 'Manual'] satisfies PitchTagging[]}
            selected={selectedConfgValues.pitchTagging}
            setSelected={(newValue) => setSelectedConfigValue('pitchTagging', newValue)}
            disabled={isLoadingReport}
          />
          <GenericRadioConfig
            label={t('Batter handedness:')}
            options={['Both', 'Left', 'Right'] satisfies PlayerHandedness[]}
            selected={selectedConfgValues.batterHandedness}
            setSelected={(newValue) => setSelectedConfigValue('batterHandedness', newValue)}
            disabled={isLoadingReport}
          />
          <GenericRadioConfig
            label={t('Pitcher handedness:')}
            options={['Both', 'Left', 'Right'] satisfies PlayerHandedness[]}
            selected={selectedConfgValues.pitcherHandedness}
            setSelected={(newValue) => setSelectedConfigValue('pitcherHandedness', newValue)}
            disabled={isLoadingReport}
          />
          <SeePitchesBy
            seePitchesBy={selectedConfgValues.pitchGrouping}
            setSeePitchesBy={(newValue) => setSelectedConfigValue('pitchGrouping', newValue)}
            pitchTypes={selectedConfgValues.pitchTypes}
            setPitchTypes={(newValue) => setSelectedConfigValue('pitchTypes', newValue)}
            pitchTypeGroups={selectedConfgValues.pitchTypeGroups}
            setPitchTypeGroups={(newValue) => setSelectedConfigValue('pitchTypeGroups', newValue)}
            disabled={isLoadingReport}
            availablePitchTypes={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypes
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypes
            }
            availablePitchTypeGroups={
              selectedConfgValues.pitchTagging === 'Auto'
                ? specialConfigOptions?.pitchTypeInfo.availableAutoPitchTypeGroups
                : specialConfigOptions?.pitchTypeInfo.availableManualPitchTypeGroups
            }
          />
        </div>
      )}
    </>
  );
};

export default AdminOverviewConfig;
